module.exports = __webpack_public_path__ + "img/left_worm_wheel.prt.60fb0774.jpg";